import classNames from 'classnames'

import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import AccordianItem, { AccordianItemProps } from '../accordianItem'

import styles from './accordian.module.scss'

export interface AccordianProps {
  data: AccordianItemProps[]
  showFirstAccordionExpanded?: boolean
  className?: string
  productProperties?: ProductProperties
  showNewPdpDesignV2?: boolean
  initialExpandedIndices?: number[]
  onItemToggle?: (index: number, isOpen: boolean) => void
}

const Accordian = ({
  data = [],
  showFirstAccordionExpanded,
  className,
  productProperties,
  showNewPdpDesignV2,
  initialExpandedIndices,
  onItemToggle,
}: AccordianProps) => {
  const classes = classNames(styles.wrapper, className, {
    [styles.wrapper_newPdpDesignV2 ?? '']: showNewPdpDesignV2,
  })

  const getInitialState = (index: number): boolean => {
    // If cached indices are provided, use them
    if (initialExpandedIndices) {
      return initialExpandedIndices.includes(index)
    }
    // Default: only expand the first item when showFirstAccordionExpanded is true
    return index === 0 && !!showFirstAccordionExpanded
  }

  return (
    <div className={classes}>
      {data.map((accordian, index) => {
        return (
          <AccordianItem
            key={accordian.key || index}
            onClick={() => {
              trackEvent(TELEMETRY_EVENT_NAMES.FAQ_CLICKED, {
                FAQ_description: accordian.header?.raw.content[0]?.content?.[0]?.value,
                productProperties,
              })
            }}
            {...accordian}
            initialState={getInitialState(index)}
            onToggle={
              onItemToggle
                ? (isOpen: boolean) => {
                    onItemToggle(index, isOpen)
                  }
                : undefined
            }
            className={showNewPdpDesignV2 ? styles.wrapper__item_newPdpDesignV2 : ''}
            showNewPdpDesignV2={showNewPdpDesignV2}
          />
        )
      })}
    </div>
  )
}

export default Accordian
